var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 15,
    viewBox: "0 0 4 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33854 2.16667C1.33854 2.53486 1.63702 2.83333 2.00521 2.83333C2.3734 2.83333 2.67188 2.53486 2.67188 2.16667C2.67188 1.79848 2.3734 1.5 2.00521 1.5C1.63702 1.5 1.33854 1.79848 1.33854 2.16667Z",
    stroke: "#151515",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33854 7.50065C1.33854 7.86884 1.63702 8.16732 2.00521 8.16732C2.3734 8.16732 2.67188 7.86884 2.67188 7.50065C2.67188 7.13246 2.3734 6.83398 2.00521 6.83398C1.63702 6.83398 1.33854 7.13246 1.33854 7.50065Z",
    stroke: "#151515",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33854 12.8327C1.33854 13.2009 1.63702 13.4993 2.00521 13.4993C2.3734 13.4993 2.67188 13.2009 2.67188 12.8327C2.67188 12.4645 2.3734 12.166 2.00521 12.166C1.63702 12.166 1.33854 12.4645 1.33854 12.8327Z",
    stroke: "#151515",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotMenu);
export default __webpack_public_path__ + "static/media/dot-menu.ba4e1f40519ddcb86fe06344f56d15a1.svg";
export { ForwardRef as ReactComponent };